import React from 'react';
import {Controller} from "react-hook-form";
import {countries} from "./DataList";
import {Info} from "@mui/icons-material";
import {Autocomplete, Box, TextField} from "@mui/material";
import {CustomTooltip} from "../landings/LandingForm";
import {getSettingsColors} from "../settings/SettingsDesign";

export default function CountrySelect({control, title, compact = false}) {
    return (
        <Controller
            render={({field: {onChange, ...props}}) => (
                <Autocomplete
                    id="country-select"
                    isOptionEqualToValue={(option, value) => option.label === value.label}
                    getOptionLabel={(option) => option.label}
                    options={countries}
                    fullWidth={compact}
                    slotProps={compact ? {paper: {sx: {
                        bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input,
                        color: 'text.primary', borderRadius: '10px', border: '1px solid', borderColor: 'divider',
                        '& .MuiAutocomplete-option': {fontSize: 13}
                    }}} : undefined}
                    renderInput={params => (
                        compact ? <TextField {...params} variant="outlined" size="small" fullWidth
                            placeholder="Select a country" label="Country" slotProps={{inputLabel: {shrink: true}}}/> :
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                    margin="dense"
                                    placeholder="Select a country"
                                    label="Country"
                                />
                            </Box>
                            <Box p={1}>
                                <Box sx={{paddingTop: "10px"}}>
                                    <CustomTooltip
                                        disableFocusListener
                                        title={title}
                                    >
                                        <Info color={"primary"} fontSize={"small"}/>
                                    </CustomTooltip>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    onChange={(e, data) => onChange(data)}
                    {...props}
                />
            )}
            name="country"
            defaultValue={{code: "", label: "Global", phone: ""}}
            control={control}
            onChange={([, data]) => data}
        />
    );
}
